export default __webpack_public_path__ + "static/media/GalanoGrotesque-SemiBold.d114d8d9.woff";